import { useEffect, useState } from 'react';
import api from '../services/api.js';
import { useVisibleLoading } from './useVisibleLoading.js';

/** Misma prioridad que `CarruselModel::allPublic`: menor `orden` primero (1 = primero); empate: `id` mayor. */
function normalizeCarouselSlides(data) {
  const raw = data == null ? [] : data;
  const list = Array.isArray(raw) ? [...raw] : Object.values(typeof raw === 'object' ? raw : {});
  return list.sort((a, b) => {
    const oa = Number(a?.orden);
    const ob = Number(b?.orden);
    const na = Number.isFinite(oa) ? oa : 0;
    const nb = Number.isFinite(ob) ? ob : 0;
    if (na !== nb) return na - nb;
    const ia = Number(a?.id);
    const ib = Number(b?.id);
    return (Number.isFinite(ib) ? ib : 0) - (Number.isFinite(ia) ? ia : 0);
  });
}

export function usePublicContent() {
  const [carrusel, setCarrusel] = useState([]);
  const [noticias, setNoticias] = useState([]);
  const [creditos, setCreditos] = useState([]);
  const [convenios, setConvenios] = useState([]);
  const [vacaciones, setVacaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const [c, n, cr, conv, v] = await Promise.all([
          api.get('/v1/public/carrusel'),
          api.get('/v1/public/noticias'),
          api.get('/v1/public/creditos'),
          api.get('/v1/public/convenios'),
          api.get('/v1/public/vacaciones'),
        ]);
        if (cancelled) return;
        setCarrusel(normalizeCarouselSlides(c.data?.data));
        setNoticias(n.data?.data ?? []);
        setCreditos(cr.data?.data ?? []);
        setConvenios(conv.data?.data ?? []);
        setVacaciones(v.data?.data ?? []);
      } catch (e) {
        if (!cancelled) setError(e.message || 'No se pudo cargar el contenido');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const visibleLoading = useVisibleLoading(loading);

  return { carrusel, noticias, creditos, convenios, vacaciones, loading: visibleLoading, error };
}
